import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeSnackbar } from 'redux/actions/actions';
import { NotificationType, RootState } from 'redux/reducers/type';
import { Button } from '@material-ui/core';
import { CloseButton } from 'components/Notifier';

let displayed: number[] = [];

const storeDisplayed = (id: number) => {
  displayed = [...displayed, id];
};

const removeDisplayed = (id: number) => {
  displayed = [...displayed.filter(key => id !== key)];
};

const MessageBox = ({ messages }: { messages: string[] }) => {
  return (
    <div>
      {messages.map((message: string, index: number) => (
        <div key={`${message}_${index}`}>{message}</div>
      ))}
    </div>
  );
};

function Notifier() {
  const dispatch = useDispatch();
  const { notifications } = useSelector((state: RootState) => state.notification);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onExited = useCallback(
    (event, key) => {
      dispatch(removeSnackbar({ key: Number(key) }));
      removeDisplayed(Number(key));
    },
    [dispatch],
  );

  useEffect(() => {
    notifications.forEach(({ key, messages, options, dismissed = false }: NotificationType) => {
      if (displayed.includes(key)) return;

      enqueueSnackbar(<MessageBox messages={messages} />, {
        key,
        variant: options.variant,
        action: key => <CloseButton key={Number(key)} />,
        onExited,
      });

      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, onExited]);

  return null;
}

export default Notifier;
